import { timeQuery } from 'helpers/Utils';
export class Article {
    constructor(props) {
        Object.assign(this, props);
        this.updated = new Date(props.updated);
        this.image = timeQuery(props.image, this.updated);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Articles/Model.ts
// module id = 328
// module chunks = 0